/* eslint-disable import/prefer-default-export */
export const RISK_CLASIFICATION = [
  { value: 'HIGH_RISK', label: 'Alto riesgo' },
  { value: 'LOW_RISK', label: 'Bajo riesgo' },
  { value: 'NO_BUSINESS_OBJECT', label: 'No objeto de negocios' },
];
